import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CasesPage from './pages/CasesPage';
import CaseDetailPage from './pages/CaseDetailPage';
import DebtorsPage from './pages/DebtorsPage';
import RequestsPage from './pages/RequestsPage';
import SettingsPage from './pages/SettingsPage';
import { authService } from './services/authService';
import type { Agent } from './types';
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState<Agent | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const user = authService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (agent: Agent) => {
    setCurrentUser(agent);
  };

  const handleLogout = () => {
    authService.logout();
    setCurrentUser(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/login" 
        element={
          currentUser 
            ? <Navigate to="/dashboard" replace /> 
            : <LoginPage onLogin={handleLogin} />
        } 
      />
      
      {/* Protected routes */}
      <Route 
        path="/dashboard" 
        element={
          currentUser 
            ? <DashboardPage user={currentUser} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/cases" 
        element={
          currentUser 
            ? <CasesPage user={currentUser} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/case/:caseId" 
        element={
          currentUser 
            ? <CaseDetailPage user={currentUser} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/debtors" 
        element={
          currentUser 
            ? <DebtorsPage user={currentUser} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/requests" 
        element={
          currentUser 
            ? <RequestsPage user={currentUser} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/settings" 
        element={
          currentUser 
            ? <SettingsPage user={currentUser} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      
      {/* Default redirect */}
      <Route path="*" element={<Navigate to={currentUser ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}

export default App;
